// /resorts — SSR head() for the resorts landing page.
import { createFileRoute } from "@tanstack/react-router";
import { getHost } from "@/lib/host";
import Resorts from "@/pages/Resorts";
import {
  canonicalOriginFromHost,
  localeFromHost,
  type LocaleKey,
} from "@/lib/locale-from-host";
import { buildHreflangLinks } from "@/lib/hreflang";

const SEO: Record<LocaleKey, { title: string; description: string }> = {
  es: {
    title: "Resorts All Inclusive | Fora da Rota",
    description:
      "Descubre los mejores resorts all inclusive del mundo. Reserva con Fora da Rota y vive una experiencia auténtica.",
  },
  "pt-BR": {
    title: "Resorts All Inclusive | Fora da Rota",
    description:
      "Descubra os melhores resorts all inclusive do mundo. Reserve com a Fora da Rota e viva uma experiência autêntica.",
  },
  en: {
    title: "All Inclusive Resorts | Fora da Rota",
    description:
      "Discover the best all inclusive resorts in the world. Book with Fora da Rota for an authentic experience.",
  },
  "en-EU": {
    title: "All Inclusive Resorts | Fora da Rota",
    description:
      "Discover the best all inclusive resorts in the world. Book with Fora da Rota for an authentic experience.",
  },
};

export const Route = createFileRoute("/resorts")({
  loader: () => {
    const host = getHost();
    return {
      locale: localeFromHost(host),
      origin: canonicalOriginFromHost(host),
    };
  },
  head: ({ loaderData }) => {
    const origin = loaderData?.origin ?? "https://www.foradarota.com";
    const locale = loaderData?.locale ?? "es";
    const seo = SEO[locale];
    const url = `${origin}/resorts`;
    return {
      meta: [
        { title: seo.title },
        { name: "description", content: seo.description },
        { property: "og:title", content: seo.title },
        { property: "og:description", content: seo.description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: seo.title },
        { name: "twitter:description", content: seo.description },
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflangLinks("/resorts"),
      ],
    };
  },
  component: Resorts,
});
